import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clock-black",
  "use": "clock-black-usage",
  "viewBox": "0 0 20 15",
  "content": "<symbol viewBox=\"0 0 20 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"clock-black\">\n    <path d=\"M10 0C5.712 0 2.222 3.365 2.222 7.5S5.712 15 10 15c4.288 0 7.778-3.365 7.778-7.5S14.288 0 10 0zm0 1.2c3.616 0 6.533 2.814 6.533 6.3 0 3.486-2.917 6.3-6.533 6.3-3.616 0-6.533-2.814-6.533-6.3 0-3.486 2.917-6.3 6.533-6.3zm0 1.5a.611.611 0 0 0-.622.6v4.2c0 .331.278.6.622.6h3.733a.611.611 0 0 0 .623-.6c0-.331-.279-.6-.623-.6h-3.11V3.3c0-.331-.28-.6-.623-.6z\" fill=\"#000\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol